<template>
  <Loading v-if="loading" />
  <aside v-else class="settings-customizations settings-policies" :key="loading">
    <div class="desc">Published on creator registration, in the creator portal settings, and in the footer of the storefront or website.</div>
    <div class="input-item-box">
      <div class="view-box" v-if="!editTerm">
        <h2>Terms & Conditions</h2>
        <time v-if="merchant.terms_and_conditions_updated_at">Updated:
          {{ moment(merchant.terms_and_conditions_updated_at).format('MMM DD, YYYY')
          }}</time>
        <div class="one-line">
          <p :class="[ !terms && 'gray-p']">{{ terms ? terms : exTerms }}</p>
          <div class="btn-wrap">
            <el-button type="primary" @click="editTerm = true; tempTerms = terms" :disabled="!permission_terms">{{ terms ? 'Edit' : 'Add'
              }}</el-button>
          </div>
        </div>
      </div>

      <div class="view-box edit-box" v-if="editTerm">
        <h2>Edit Terms & Conditions</h2>
        <div class="one-line">
          <div class="input-box">
            <el-input v-model="terms" @blur="validateField('terms')"
              :placeholder="exTerms"></el-input>
            <div v-if="err.terms" class="error-message">
              <p>*Please enter a valid URL starting with http:// or https://</p>
            </div>
          </div>
          <div class="btn-wrap bottom">
            <el-button type="primary" text
              @click="terms = tempTerms; editTerm = false; err.terms = '';">Cancel</el-button>
            <el-button type="primary" :disabled="!terms || tempTerms === terms" @click="save('terms')">{{ terms ? 'Save'
              :
              'Add' }}</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- policy -->
    <div class="input-item-box">
      <div class="view-box" v-if="!editPolicy">
        <h2>Privacy Policy</h2>
        <time v-if="merchant.privacy_policy_updated_at">Updated:
          {{ moment(merchant.privacy_policy_updated_at).format('MMM DD, YYYY') }}</time>
        <div class="one-line">
          <p :class="[ !policy && 'gray-p']">{{ policy ? policy : exPolicy }}</p>
          <div class="btn-wrap">
            <el-button type="primary" @click="editPolicy = true; tempPolicy = policy" :disabled="!permission_policy">{{ policy ? 'Edit' : 'Add'
              }}</el-button>
          </div>
        </div>
      </div>

      <div class="view-box edit-box" v-if="editPolicy">
        <h2>Edit Privacy Policy</h2>
        <div class="one-line">
          <div class="input-box">
            <el-input v-model="policy" @blur="validateField('policy')"
              :placeholder="exPolicy"></el-input>
            <div v-if="err.policy" class="error-message">
              <p>*Please enter a valid URL starting with http:// or https://</p>
            </div>
          </div>
          <div class="btn-wrap bottom">
            <el-button type="primary" text
              @click="policy = tempPolicy; editPolicy = false; err.policy = ''">Cancel</el-button>
            <el-button type="primary" :disabled="!policy||tempPolicy === policy" @click="save('policy')">{{ policy ?
              'Save' : 'Add' }}</el-button>
          </div>
        </div>
      </div>
    </div>

  </aside>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance, computed } from 'vue';
import { ElButton, ElInput } from 'element-plus';
import { useStore } from 'vuex';
import Loading from '@/components/ui/Loading.vue';
import moment from 'moment';

const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const terms = ref('');
const tempTerms = ref('');
const editTerm = ref(false);
const policy = ref('');
const tempPolicy = ref('');
const editPolicy = ref(false);
const err = ref({
  terms: false,
  policy: false,
});
const loading = ref(false);
const store = useStore();
const merchant= computed(() => store.state.user_data.merchant_account);
const exTerms= computed(() => {
  return `Example: ${merchant.value.main_domain}/terms-of-use`;
});
const exPolicy = computed(() => {
  return `Example: ${merchant.value.main_domain}/privacy-policy`;
});
const permission_terms=computed(()=>{
  return store.state.user_data?.permission_list?.settingIntegrations?.addOrEditTermsAndConditions.permission;
});
const permission_policy=computed(()=>{
  return store.state.user_data?.permission_list?.settingIntegrations?.addOrEditPrivacyPolicy.permission;
})
//+++++++++++++++++++++++++++++++++
const isValidHttpURL = (str) => {
  try {
    // if(!str){
    //   return true;
    // }
    const url = new URL(str);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch (_) {
    return false;
  }
};

const validateField = (field) => {
  const value = field === 'terms' ? terms.value : policy.value;
  err.value[field] = !isValidHttpURL(value);
};

const save = (type) => {
  //call api

  if (type === 'terms') {
    if (err.value.terms) return;
    loading.value = true;
    ajax.post('/settings/update-terms-and-conditions', {
      terms_and_conditions: terms.value
    }).then((res) => {
      store.state.user_data.merchant_account.terms_and_conditions = terms.value;
      err.terms = '';
      editTerm.value = false;
      loading.value = false;
      window.location.reload();
    }).catch((error) => {
      console.error('Error saving terms:', error);
      err.terms = 'An error occurred while saving the terms and conditions.';
      loading.value = false;
    });

  } else if (type === 'policy') {
    if (err.value.policy) return;
    loading.value = true;
    ajax.post('/settings/update-privacy-policy', {
      privacy_policy: policy.value
    }).then((res) => {
      policy.value = store.state.user_data.merchant_account.privacy_policy = policy.value;
      err.policy = '';
      editPolicy.value = false;
      loading.value = false;
      window.location.reload();
    }).catch((error) => {
      console.error('Error saving policy:', error);
      err.policy = 'An error occurred while saving the privacy policy.';
      loading.value = false;
    });

  }
}

//++++++++++++++++++++++++
onMounted(() => {
  terms.value = store.state.user_data.merchant_account.terms_and_conditions;
  policy.value = store.state.user_data.merchant_account.privacy_policy;
});
</script>
<style lang="scss">
.settings-policies {
  display: grid;
  gap: 16px;

  time {
    font: var(--medium-12);
    color: var(--Text-default);
    margin: 0;
    white-space: nowrap;
  }

  .desc {
    color: var(--black-75);
  }


  .input-item-box {

    &.can-edit {
      cursor: pointer;
    }

    .one-line {
      display: flex;
      gap: 16px;
      align-items: center;

      p ,.input-box{
        flex: 1;
      }
    }

    h2 {
      font: var(--font-med-16);
      color: var(--black-90);
      margin: 0 0 8px;
    }

    p {
      font: var(--font-med-14);
      color: var(--black-75);

      &.gray-p{
        color: var(--black-40);
      }
    }

    .btn-wrap {
      text-align: right;
    }

    .error-message p {
      color: var(--alert);
      font-size: 12px;
      text-align: right;
    }

    .view-box {
      border: 1px solid #E0E0E0;
      border-radius: 8px;
      padding: 16px;
      width: 100%;

      &.edit-box {
        background-color: var(--bg-10);
        border: none;
      }
    }


  }
}
</style>
